import { Dialog, DialogTitle, Divider, Grid, Paper, TextField, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import AddIcon from "@material-ui/icons/Add";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Form, Formik } from "formik";
import MaterialTable from "material-table";
import Labels from "../../../../../lang/Labels_en";
import { preventDefaultEnter } from "../../../../../utils/Utils";
import { tableIcons } from "../../../../system/material-table-utils/MaterialTableUtils";
import ReviewersModal from "./modal/ReviewersModal";
import ReviewersService, { ReviewersServiceType } from "./ReviewersService";
import useStyles from "./ReviewersStyle";

export default function Reviewers({ article, setArticle, handleNext, handleBack }: any) {
  const { articleSave, reviewerList, open, setOpen, openModal, closeModal }: ReviewersServiceType = ReviewersService();
  const classes = useStyles();

  return (
    <div>
      <CssBaseline />
      <div className={classes.layout}>
        <Paper className={classes.paper}>
          <Typography>
            We encourage you to nominate up to two reviewers whom you regard as authorities competent to evaluate your
            work. The reviewer nominations serve as a reference for the Editor in Chief. The reviewers chosen should
            preferably be experts who have no relationship with the authors. If the authors decide to nominate reviewers
            with a past or present relationship, a declaration of the association must be made.{" "}
          </Typography>
          <Formik
            initialValues={{
              reviewerOne: article.reviewerOne ? article.reviewerOne : null,
              reviewerTwo: article.reviewerTwo ? article.reviewerTwo : null,
              reviewerRemoved: article.reviewerRemoved ? article.reviewerRemoved : null,
              relationshipOne: article.relationshipOne ? article.relationshipOne : "",
              relationshipTwo: article.relationshipTwo ? article.relationshipTwo : "",
              note: article.note ? article.note : "",
            }}
            onSubmit={(values) => articleSave(values, article, setArticle, handleNext)}
          >
            {({ handleBlur, values, touched, errors, handleChange, handleSubmit, setFieldValue }) => (
              <Form onKeyDown={preventDefaultEnter}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      options={reviewerList}
                      getOptionLabel={(option): any => option.name}
                      value={values.reviewerOne}
                      onChange={(event, value) => setFieldValue("reviewerOne", value)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          margin="normal"
                          id="reviewerOne"
                          name="reviewerOne"
                          onBlur={handleBlur}
                          label={Labels.REVIEWER_1_NAME}
                          error={touched.reviewerOne && Boolean(errors.reviewerOne)}
                          helperText={touched.reviewerOne && errors.reviewerOne}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      id="relationshipOne"
                      name="relationshipOne"
                      label={Labels.REVIEWER_1_RELATIONSHIP}
                      value={values.relationshipOne}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.relationshipOne && Boolean(errors.relationshipOne)}
                      helperText={touched.relationshipOne && errors.relationshipOne}
                      fullWidth
                      // required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      options={reviewerList}
                      getOptionLabel={(option): any => option.name}
                      value={values.reviewerTwo}
                      onChange={(event, value) => setFieldValue("reviewerTwo", value)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          margin="normal"
                          id="reviewerTwo"
                          name="reviewerTwo"
                          onBlur={handleBlur}
                          label={Labels.REVIEWER_2_NAME}
                          error={touched.reviewerTwo && Boolean(errors.reviewerTwo)}
                          helperText={touched.reviewerTwo && errors.reviewerTwo}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      id="relationshipTwo"
                      name="relationshipTwo"
                      label={Labels.REVIEWER_2_RELATIONSHIP}
                      value={values.relationshipTwo}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.relationshipTwo && Boolean(errors.relationshipTwo)}
                      helperText={touched.relationshipTwo && errors.relationshipTwo}
                      fullWidth
                      // required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography>
                      If you have a past relationship with one or both of these reviewers, please declare it in the box
                      below their names. If you want to you may also select a reviewer that you do not want to review
                      your article.{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      options={reviewerList}
                      getOptionLabel={(option: any) => option.name}
                      value={values.reviewerRemoved}
                      onChange={(event, value) => setFieldValue("reviewerRemoved", value)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          margin="normal"
                          id="reviewerRemoved"
                          name="reviewerRemoved"
                          onBlur={handleBlur}
                          label={Labels.REVIEWER_EXCLUDED}
                          error={touched.reviewerRemoved && Boolean(errors.reviewerRemoved)}
                          helperText={touched.reviewerRemoved && errors.reviewerRemoved}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      id="note"
                      name="note"
                      label={Labels.NOTE}
                      value={values.note}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.note && Boolean(errors.note)}
                      helperText={touched.note && errors.note}
                      fullWidth
                      // required
                    />
                  </Grid>
                </Grid>
                <div className={classes.buttons}>
                  <Button variant="outlined" color="primary" onClick={handleBack} className={classes.button}>
                    {Labels.BACK}
                  </Button>
                  <Button variant="contained" color="primary" type="submit" className={classes.button}>
                    {Labels.NEXT}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Paper>
        <Paper className={classes.paperRight}>
          <div className={classes.suggestReviewerTitle}>
            <Typography>{Labels.SUGGEST_REVIEWER}</Typography>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={(e: any) => {
                openModal();
              }}
            >
              New
            </Button>
          </div>
          <div>
            <MaterialTable
              icons={tableIcons}
              columns={[
                { field: "fullName", title: Labels.FULLNAME },
                { field: "email", title: Labels.EMAIL },
              ]}
              data={article.suggestedReviewers}
              options={{
                search: false,
                actionsColumnIndex: -1,
                pageSize: 10,
                toolbar: false,
              }}
            />
          </div>
        </Paper>
        <Dialog
          open={open}
          onClose={() => {
            closeModal();
          }}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">{Labels.SUGGEST_REVIEWER}</DialogTitle>
          <ReviewersModal article={article} setOpen={setOpen} setArticle={setArticle} />
        </Dialog>
      </div>
    </div>
  );
}
